import { render } from "./App.vue?vue&type=template&id=48af0d33"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=48af0d33&lang=css"

import exportComponent from "/home/geangeowle/Workspace/NT-Marketing-Digital/ecolatas/ecolatas-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__